module.exports = __webpack_public_path__ + "assets/images/a6f304e13df84966052997ae0ea6e2aa.png";